import { useEffect, useState } from 'react';

/**
 * Drives a temporary visual highlight. The highlight turns on whenever
 * `isActive` becomes true and automatically turns off after `durationMs`.
 * Re-activating restarts the timer, so the highlight replays each time
 * `isActive` transitions back to true.
 */
export function useHighlightTimer(isActive: boolean, durationMs: number): boolean {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!isActive) {
            setIsVisible(false);
            return;
        }

        setIsVisible(true);
        const timer = setTimeout(() => setIsVisible(false), durationMs);

        return () => clearTimeout(timer);
    }, [isActive, durationMs]);

    return isVisible;
}
